module.exports = __webpack_public_path__ + "img/Gil.78ef4e72.png";